import img1 from '../components/assets/images/Featured_Products/butterfly valve.jpeg';
import img2 from '../components/assets/images/Featured_Products/First stage regulator.jpeg';
import img3 from '../components/assets/images/Featured_Products/fisher Flanged Control.jpeg';
import img4 from '../components/assets/images/Featured_Products/Greyline-pdfm50 Instrument.jpeg';
import img5 from '../components/assets/images/Featured_Products/Regulator high pressure.jpeg';
import img6 from '../components/assets/images/Featured_Products/Instrument.jpg';


export const FEATURED_PRODUCTS =[
    {
        id:0,
        name: "Valve",
        image: img1,
        featured: false,
    },
    {
        id:1,
        name: "First stage Regulator",
        image: img2,
        featured: false,
    },
    {
        id:2,
        name: "Flange Control",
        image: img3,
        featured: false,
    },
    {
        id:3,
        name: "Rosemount-Instrument",
        image: img4,
        featured: false,
    },
    {
        id:4,
        name: "Regulator",
        image: img5,
        featured: false,
    },
    {
        id:5,
        name: "Instrument",
        image: img6,
        featured: true
    }
    
]